// src/components/TransportTodayReportForm.jsx
/* global axios */
import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

function TransportTodayReportForm() {
  // 1) ----------------------------
  // NEU: State für das ausgewählte Datum
  const [selectedDate, setSelectedDate] = useState(() => {
    const heute = new Date();
    const yyyy = heute.getFullYear();
    const mm = String(heute.getMonth() + 1).padStart(2, '0');
    const dd = String(heute.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`; // Default = heute
  });

  const [transports, setTransports] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [drivers, setDrivers] = useState([]);
const [selectedDriver, setSelectedDriver] = useState('');

  // 2) ----------------------------
  // Immer, wenn sich `selectedDate` ändert, lade die passenden Transporte
 useEffect(() => {
  const fetchTransports = async () => {
    setLoading(true);
    setError('');
    try {
      const params = { date: selectedDate };
      if (selectedDriver) params.driverId = selectedDriver;
      const response = await api.get('/transportToday/todayForm', { params });
      setTransports(response.data);
    } catch (err) {
      setError('Daten konnten nicht geladen werden.');
      setTransports([]);
    } finally {
      setLoading(false);
    }
  };
  fetchTransports();
}, [selectedDate, selectedDriver]);

  useEffect(() => {
  // Lade alle Fahrer (angenommen: Rolle=driver)
  api.get('/employees?role=driver')
    .then(res => setDrivers(res.data))
    .catch(() => setDrivers([]));
}, []);

  // 3) ----------------------------
  // Gruppierung nach Fahrzeugname
  const groupedByVehicle = {};
  transports.forEach(tour => {
    const vehicleName = tour.vehicle?.name || 'Unbekanntes Fahrzeug';
    if (!groupedByVehicle[vehicleName]) {
      groupedByVehicle[vehicleName] = [];
    }
    groupedByVehicle[vehicleName].push(tour);
  });

  // 4) ----------------------------
  // PDF-Download: URL mit ?date=
  const handleDownloadPDF = () => {
    const baseURL = api.defaults.baseURL; // z.B. http://localhost:3001
    const url = `${baseURL}/transportToday/todayReport/pdf?date=${selectedDate}${selectedDriver ? `&driverId=${selectedDriver}` : ''}`;
    window.open(url, '_blank');
  };

  // 5) ----------------------------
  return (
    <div style={{ maxWidth: '1000px', margin: 'auto', padding: '20px' }}>
      <Helmet>
        <title>Transport nach Datum</title>
        <meta name="description" content="Transport nach ausgewähltem Datum" />
      </Helmet>

      {/* Überschrift mit ausgewähltem Datum */}
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
        Transportdaten für den {' '}
        {new Date(selectedDate).toLocaleDateString('de-DE')}
      </h2>

      {/* Datumspicker und PDF-Button */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' , }}>
        <label style={{ marginRight: '10px', marginTop: '-20px' }}>
          &nbsp;
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc',  }}
          />
        </label>
        <select
  value={selectedDriver}
  onChange={e => setSelectedDriver(e.target.value)}
  style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc', marginRight: '25px', marginTop: '0px', maxWidth: '200px' }}
>
  <option value="">Alle Fahrer</option>
  {drivers.map(driver => (
    <option value={driver.id} key={driver.id}>
      {driver.firstName} {driver.lastName}
    </option>
  ))}
</select>
        <button
          onClick={handleDownloadPDF}
          style={{
            padding: '6px 12px',
            background: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginTop:'-14px',
          }}
        >
          PDF herunterladen
        </button>
      </div>

      {/* Lade- und Fehlermeldungen */}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {loading && <p>Lade Transport-Daten…</p>}

      {/* Falls keine Transporte vorhanden sind */}
      {!loading && transports.length === 0 && !error && (
        <p>
          Für den {new Date(selectedDate).toLocaleDateString('de-DE')} sind
          keine Transporte geplant.
        </p>
      )}

      {/* 6) Gruppierte Anzeige pro Fahrzeug */}
      {!loading && transports.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          {Object.keys(groupedByVehicle).map((vehicleName) => (
            <div key={vehicleName} style={{ marginBottom: '30px' }}>
              <h3
                style={{
                  borderBottom: '1px solid #444',
                  paddingBottom: '4px'
                }}
              >
                {vehicleName} – {groupedByVehicle[vehicleName][0].vehicle?.licensePlate || '-'}
              </h3>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f0f0f0' }}>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      Tour
                    </th>
                    
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      Zeitraum
                    </th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      Fahrer
                    </th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      Marker
                    </th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Firma</th>
                   <th style={{ padding: '8px', border: '1px solid #ddd' }}>Artikel</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      Zeitpunkt
                    </th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      Ort
                    </th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>
                      Notizen
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {groupedByVehicle[vehicleName].map((tour, i) =>
                    tour.markers.map((marker, j) => (
                      <tr key={`${i}-${j}`}>
                        <td
                          style={{ padding: '8px', border: '1px solid #ddd' }}
                        >
                          {tour.tourName}
                        </td>
                       
                        <td
                          style={{ padding: '8px', border: '1px solid #ddd' }}
                        >
                          {tour.timeframeFrom} – {tour.timeframeTo}
                        </td>
                        <td
                          style={{ padding: '8px', border: '1px solid #ddd' }}
                        >
                          {tour.driver
                            ? `${tour.driver.firstName} ${tour.driver.lastName}`
                            : '-'}
                        </td>
                        <td
                          style={{ padding: '8px', border: '1px solid #ddd' }}
                        >
                          {marker.markerType}
                        </td>
                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                         {marker.orderItem?.order?.customer?.company || '-'}
                       </td>
                       <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                         {marker.orderItem?.item?.name || '-'}
                       </td>
                        <td
                          style={{ padding: '8px', border: '1px solid #ddd' }}
                        >
                          {marker.sortTime}
                        </td>
                        <td
                          style={{ padding: '8px', border: '1px solid #ddd' }}
                        >
                          {marker.markerType === 'pickup'
                            ? marker.operationLocationPickup || '-'
                            : marker.operationLocationDelivery || '-'}
                        </td>
                        <td
                          style={{ padding: '8px', border: '1px solid #ddd' }}
                        >
                          {marker.transportNotes || '-'}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TransportTodayReportForm;
